import { Box, Typography } from '@mui/material';
import { OneClick } from '@/components/blocks/OneClick';
import { PriceDisplay } from '@/components/blocks/PriceDisplay';
import { useModalOutfitsContext } from '@/components/blocks/ModalOutfits/parts/OutfitsProvider';

interface OutfitFooterProps {}

export const OutfitFooter: React.FC<OutfitFooterProps> = () => {
	const { totalSelectedAmount, addToCart, isValidSizesSelection, onClose } =
		useModalOutfitsContext();

	const handleAddToCart = async (event: React.MouseEvent<HTMLButtonElement>) => {
		await addToCart(event);
		onClose();
	};

	return (
		<Box
			sx={{
				width: '100%',
				display: 'flex',
				flexDirection: 'row',
				justifyContent: 'space-between',
				alignItems: 'center',
				height: { xs: '80px', md: 'auto' },
			}}
		>
			<Box>
				<Typography
					sx={{
						color: '#313131',
						fontSize: '14px',
						fontWeight: 400,
					}}
				>
					{'Comprar look'}
				</Typography>
				<Typography
					sx={{
						color: '#313131',
						fontSize: '18px',
						fontWeight: 800,
					}}
				>
					<PriceDisplay min={totalSelectedAmount} />
				</Typography>
			</Box>
			<OneClick
				wrapper="button-base"
				sx={{
					width: { xs: '214px', md: '239px' },
					backgroundColor: '#FF4900',
					color: '#FFFFFF',
					fontSize: '15px',
					fontWeight: 'bold',
					borderRadius: '22px',
					height: '50px',
					'&:hover': { backgroundColor: '#d83f01' },
					'&:disabled': { backgroundColor: '#d3d3d3' },
				}}
				disabled={totalSelectedAmount === 0 || !isValidSizesSelection}
				onClick={handleAddToCart}
			>
				{'Agregar todo al carrito'}
			</OneClick>
		</Box>
	);
};
